<template>
  <div class="full-width-image" ref="imageContainer">
    <!-- Imagen de fondo -->
    
    <!-- SVG decorativo animado -->
    <svg
      ref="waveSvg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1440 320"
      class="animated-wave"
    >
      <!-- 1. Línea animada (solo trazo) -->
      <path
        ref="wavePathStroke"
        class="wave-path-stroke"
        d="M0,256L80,240C160,224,320,192,480,186.7C640,181,800,203,960,208C1120,213,1280,203,1360,197.3L1440,192L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z"
      ></path>

      <!-- 2. Relleno que aparece después -->
      <path
        ref="wavePathFill"
        class="wave-path-fill"
        d="M0,256L80,240C160,224,320,192,480,186.7C640,181,800,203,960,208C1120,213,1280,203,1360,197.3L1440,192L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z"
      ></path>
    </svg>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { gsap } from 'gsap';

export default {
  name: 'FullWidthImage',
  setup() {
    const mainImage = ref(null);
    const waveSvg = ref(null);
    const wavePathStroke = ref(null);
    const wavePathFill = ref(null);
    const imageContainer = ref(null);

    const animateIn = () => {
      const pathLength = wavePathStroke.value.getTotalLength();
      wavePathStroke.value.style.strokeDasharray = pathLength;
      wavePathStroke.value.style.strokeDashoffset = pathLength;

      gsap.timeline()
        .fromTo(imageContainer.value,
          { opacity: 0, y: 100 },
          { opacity: 1, y: 0, duration: 1.2, ease: 'power3.out' })
        .fromTo(mainImage.value,
          { opacity: 0, scale: 1.1 },
          { opacity: 1, scale: 1, duration: 1.5, ease: 'power4.out' },
          '-=1')
        .fromTo(waveSvg.value,
          { opacity: 0, y: 100 },
          { opacity: 1, y: 0, duration: 1.3, ease: 'power2.out' },
          '-=1')
        .to(wavePathStroke.value,
          { strokeDashoffset: 0, duration: 2, ease: 'power2.inOut' },
          '-=1')
        .to(wavePathFill.value,
          { opacity: 1, duration: 1.2, ease: 'power1.out' },
          '-=0.8');
    };

    onMounted(() => {
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            animateIn();
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.3 });

      if (imageContainer.value) observer.observe(imageContainer.value);
    });

    return {
      mainImage,
      waveSvg,
      wavePathStroke,
      wavePathFill,
      imageContainer
    };
  }
};
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
      background-image: url('@/assets/fondito.avif'); /* Ruta a tu imagen */

  overflow-x: hidden;
}

.full-width-image {
  width: 100%;
  position: relative;
  overflow: hidden;
margin-top:-10px;
  z-index: 1;
  opacity: 0;
  transform: translateY(100px);
}

.full-width-image img {
  width: 100%;
  height: auto;
  display: block;
  opacity: 0;
  transform: scale(1.1);
}

.animated-wave {
  position: relative;
  bottom: 0;
  left: 0;
  width: 100%;
  height: auto;
  pointer-events: none;
  z-index: 2;
  opacity: 0;
  transform: translateY(100px);
}

.wave-path-stroke {
  fill: none;
  stroke: #31050b;
  stroke-width: 3;
}

.wave-path-fill {
  fill: #31050b;
  opacity: 0;
}
</style>
